import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { sendResetEmail } from 'shared/api/auth';
import { useNotification, useRequest } from 'shared/hooks';
import { VARIANTS } from 'shared/constants';
import { TextEditor } from 'shared/components/data-display/editors';

export default function ResetPassword() {
  const { search } = useLocation();
  const history = useHistory();
  const { isLoading } = useRequest();
  const searchParams = new URLSearchParams(search);
  const [email, setEmail] = useState(searchParams.get('username') || '');
  const notification = useNotification();

  const submitReset = () => {
    sendResetEmail(email)
      .then(() => notification.pushSuccess('Sent mail'))
      .catch((err) => notification.pushError(err))
      .finally(() => history.push('/'));
  };

  return (
    <Grid container sx={{ justifyContent: 'end' }}>
      <Grid size={12}>
        <TextEditor
          type="email"
          required
          setValue={(value) => setEmail(value)}
          label="Email"
          value={email}
        />
      </Grid>
      <Grid>
        <Button
          variant={VARIANTS.outlined}
          type="submit"
          disabled={isLoading || email === ''}
          onClick={submitReset}
        >
          Send Recovery Email
        </Button>
      </Grid>
    </Grid>
  );
}
